type Lang = "hr" | "en";

const HR_WEEKDAYS = [
  "nedjelja",
  "ponedjeljak",
  "utorak",
  "srijeda",
  "četvrtak",
  "petak",
  "subota",
];

const EN_WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const EN_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

function parse(iso: string): Date | null {
  if (typeof iso !== "string" || iso.length === 0) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

export function dayKey(iso: string): string {
  const d = parse(iso);
  if (!d) return "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

function localDayNumber(d: Date): number {
  return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
}

export function dayLabel(iso: string, now: Date, lang: Lang): string {
  const d = parse(iso);
  if (!d) return "";
  const nowValid = now instanceof Date && !Number.isNaN(now.getTime());
  if (!nowValid) return "";
  const diff = localDayNumber(now) - localDayNumber(d);
  if (diff === 0) return lang === "hr" ? "Danas" : "Today";
  if (diff === 1) return lang === "hr" ? "Jučer" : "Yesterday";
  if (diff >= 2 && diff <= 6) {
    const wd = d.getDay();
    return lang === "hr" ? HR_WEEKDAYS[wd] : EN_WEEKDAYS[wd];
  }
  const day = d.getDate();
  const month = d.getMonth();
  const year = d.getFullYear();
  if (lang === "hr") {
    return `${day}. ${month + 1}. ${year}.`;
  }
  return `${day} ${EN_MONTHS[month]} ${year}`;
}

export function timeLabel(iso: string, _lang: Lang): string {
  const d = parse(iso);
  if (!d) return "";
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
